/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import { Modal as ShowroomModal } from '@carvana/core-helios-modal';
import { datadogRum } from '@datadog/browser-rum';
import { Analytics } from '@services/analytics-service';
import { AnalyticEvents } from '@constants/index';
import { useSnapshot } from 'valtio';
import { SarStore } from '@store/sar-store';
import { Route, ROUTES, useRouter } from '../../providers/router';
import styles from '../../service-and-repair.module.css';
import { Categories } from '../../pages/categories';
import { SubCategories } from '../../pages/subcategories';
import { SubSubCategories } from '../../pages/subsubcategories';
import { Locations } from '../../pages/locations';
import { Mileage } from '../../pages/mileage';
import { ImageUpload } from '../../pages/image-upload';
import { MileageTooHigh } from '../../pages/mileage-too-high';
import { Coverage } from '../../pages/coverage-page';
import { useUserSelections } from '../../providers/user-selections';
import { IssueSubmitted } from '../../pages/issue-submitted';
import { BenefitsPage } from '../../pages/benefits-page/benefits-page';
import { PaintedDoor } from '../../pages/painted-door/painted-door';
import { VehicleConcernDetails } from '../../pages/vehicle-concern-details';
import { LoadingScreen } from '../loading-screen';

export const Modal = ({ closeModal, feedData }: any) => {
  const { goBack, showBackButton, currentRoute } = useRouter();
  const { setUserFeedData, userSelections } = useUserSelections();
  const { isTreatmentV1, isTreatmentV2, text } = useSnapshot(SarStore.paintedDoor);

  const handleBack = () => {
    Analytics.trackEvent(AnalyticEvents.sarClickedBackButton);
    datadogRum.addAction(AnalyticEvents.sarClickedBackButton);
    goBack();
  };

  useEffect(() => {
    if (feedData) {
      setUserFeedData({
        ...feedData,
        coverage: feedData?.coverage?.filter((x: any) => !x.isExpired),
      });
    }
  }, [feedData]);

  const onModalClose = () => {
    const isEndOfCosmeticSubmitted = currentRoute === ROUTES.COVERAGE && userSelections?.media?.length;
    
    if (isEndOfCosmeticSubmitted) {
      window.location.reload();
    }

    if (currentRoute === ROUTES.PAINTED_DOOR) {
      Analytics.trackEvent(AnalyticEvents.paintedDoorDismissed, { isTreatmentV1, isTreatmentV2, text });
      datadogRum.addAction(AnalyticEvents.paintedDoorDismissed, { isTreatmentV1, isTreatmentV2, text });
    }
  };

  return (
    <ShowroomModal
      isOpen
      closeModal={closeModal}
      headerText="Service and repair"
      className={styles['modal']}
      closeCallback={onModalClose}
      {...(showBackButton ? { onClickBack: handleBack } : {})}
    >
      <div className={styles['modal-content']} id="modal-content">
        <Route path={ROUTES.PAINTED_DOOR} component={<PaintedDoor />} />
        <Route path={ROUTES.CATEGORIES} component={<Categories />} />
        <Route path={ROUTES.SUB_CATEGORIES} component={<SubCategories />} />
        <Route path={ROUTES.SUB_SUB_CATEGORIES} component={<SubSubCategories />} />
        <Route path={ROUTES.VEHICLE_CONCERN_DETAILS} component={<VehicleConcernDetails />} />
        <Route path={ROUTES.LOCATIONS} component={<Locations />} />
        <Route path={ROUTES.MILEAGE} component={<Mileage />} />
        <Route path={ROUTES.MILEAGE_TOO_HIGH} component={<MileageTooHigh />} />
        <Route path={ROUTES.IMAGE_UPLOAD} component={<ImageUpload />} />
        <Route path={ROUTES.ISSUE_SUBMITTED} component={<IssueSubmitted />} />
        <Route path={ROUTES.COVERAGE} component={<Coverage />} />
        <Route path={ROUTES.BENEFITS} component={<BenefitsPage />} />
        <Route path={ROUTES.LOADING} component={<Loading />} />
      </div>
    </ShowroomModal>
  );
};

export default Modal;

const Loading = () => {
  useEffect(() => {
    const modalContent = document.getElementById('modal-content');
    if (modalContent) {
      modalContent.style.height = '100%';
    }

    return () => {
      if (modalContent) {
        modalContent.style.height = '';
      }
    };
  }, []);

  return <LoadingScreen />;
};
